/**
 * Named date periods for report pages — Today, Yesterday, This week, Last
 * week, This month, Last month — as { date_from, date_to } in the browser's own calendar,
 * which is the shop's. Weeks start on Monday.
 */

// YYYY-MM-DD in local time.
export const iso = (d) => {
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60_000)
  return local.toISOString().slice(0, 10)
}

/** { date_from, date_to } for a named period, or null for any other. */
export function periodRange(period) {
  const today = new Date()
  const day = (today.getDay() + 6) % 7          // Monday 0 … Sunday 6
  const monday = new Date(today)
  monday.setDate(today.getDate() - day)
  if (period === 'today') return { date_from: iso(today), date_to: iso(today) }
  if (period === 'yesterday') {
    const yesterday = new Date(today)
    yesterday.setDate(today.getDate() - 1)
    return { date_from: iso(yesterday), date_to: iso(yesterday) }
  }
  if (period === 'this_week') return { date_from: iso(monday), date_to: iso(today) }
  if (period === 'last_week') {
    const start = new Date(monday)
    start.setDate(monday.getDate() - 7)
    const end = new Date(monday)
    end.setDate(monday.getDate() - 1)
    return { date_from: iso(start), date_to: iso(end) }
  }
  if (period === 'this_month') {
    return { date_from: iso(new Date(today.getFullYear(), today.getMonth(), 1)), date_to: iso(today) }
  }
  if (period === 'last_month') {
    return {
      date_from: iso(new Date(today.getFullYear(), today.getMonth() - 1, 1)),
      date_to: iso(new Date(today.getFullYear(), today.getMonth(), 0)),
    }
  }
  return null
}
